import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import plus_icon from "../../assets/images/icon/plus.svg";

import { getEnquiriesAPI } from "../../helpers/backend_helper";
import { checkPermissionStatus } from "helpers/utils";
import { useTranslation } from "react-i18next";
import SearchBar from "components/Common/Searchbar";

const EnquiryList = () => {
  const { t } = useTranslation();

  const [enquiryList, setEnquiryList] = useState([]);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const tableWrapperRef = useRef(null);

 

  /* =========================
     FETCH ENQUIRIES
  ========================== */

  const fetchEnquiries = (page = currentPage, size = sizePerPage) => {
    getEnquiriesAPI({ search: query, page, sizePerPage: size })
      .then(res => {
        if (res?.status) {
          setEnquiryList(res.data);
          setTotalSize(res.total);
          setCurrentPage(page);
          setSizePerPage(size);
          console.log("API response:", res);
          console.log("Enquiry list:", res.data);
          console.log("Total size:", res.total); // 🔍 Total count
        } else {
          setEnquiryList([]);
          setTotalSize(0);
        }
      })
      .catch(err => {
        console.error("Error fetching enquiries:", err);
        setEnquiryList([]);
        setTotalSize(0);
      });
  };



  useEffect(() => {
  setCurrentPage(1);
  fetchEnquiries(1, sizePerPage);
      document.title = "NeuroTal - Enquiry List";
}, [query]);


  /* =========================
     TABLE DATA (SAFE KEY)
  ========================== */
  const tableData = enquiryList;

  /* =========================
     PAGINATION
  ========================== */
const customTotal = (from, to, size) => {
  if (size === 0) {
    return <span>Showing rows 0 to 0 of 0</span>;
  }

  const safeFrom = Math.max(from, 1);
  const safeTo = Math.min(to, size);

  return (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {safeFrom} to {safeTo} of {size}
    </span>
  );
};


  const options = {
    paginationSize: 5,
    pageStartIndex: 1,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    firstPageText: "«",
    prePageText: "<",
    nextPageText: ">",
    lastPageText: "»",
  };

  /* =========================
     TABLE COLUMNS
  ========================== */
  const columns = [
    {
      dataField: "ticket_no",
      text: t("Enquiry.Ticket No"),
      formatter: (cell, row) => (
        <Link to={`/enquiries/${row.id}`} className="blue-color4">
          {cell}
        </Link>
      ),
    },
    {
      dataField: "subject",
      text: t("Enquiry.Subject"),
    },
    {
      dataField: "status",
      text: t("Enquiry.Status"),
      formatter: cell => (
        <span
          className={`badge ${
            cell === "OPEN"
              ? "bg-warning"
              : cell === "IN_PROGRESS"
              ? "bg-info"
              : "bg-success"
          }`}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: "created_at",
      text: t("Enquiry.Created At"),
      formatter: cell => moment(cell).format("DD MMM YYYY"),
    },
    {
      dataField: "createdBy.name",
      text: t("Enquiry.Created By"),
      formatter: (cell, row) => <>{row.createdBy?.name}</>,
    },
  ];

  const rowClasses = (row, rowIndex) =>
    rowIndex % 2 === 0 ? "even-row" : "odd-row";

  /* =========================
     SCROLL HANDLER
  ========================== */
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -100 : 100,
        behavior: "smooth",
      });
    }
  };
   /* =========================
     PERMISSION CHECK
  ========================== */
  
  if (!checkPermissionStatus("enquiries", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t("Common.Access Denied")}</h4>
      </div>
    );
  }
  /* =========================
     RENDER
  ========================== */
  return (
    <div className="pending-list-page feedbacks departmentpage">
      <div className="tab-content">
        <div className="joblist-container create-vacancy main-pages-s">
          <Row className="mb-2 align-items-center">
            <Col lg="6">
              <Link to="/dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="back" />
                  {t("Enquiry.Enquiry List")}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper applicationcard-table">
          <div className="tabel-application table-responsive pb-3">
            <div className="table-data-search pbresop">
              <div className="total-record">
                <h5>
                  {t("Enquiry.Total Records")}:<span> {totalSize}</span>
                </h5>
              </div>

              <div className="total-serachbar">
                <SearchBar
                  onSearch={fetchEnquiries}
                  title={t("Enquiry.Search by subject")}
                  placeholder={t("Enquiry.Search by subject")}
                  query={query}
                  setQuery={setQuery}
                />

                {checkPermissionStatus("enquiries", "create") && (
                  <div className="take-text filter">
                    <Link
                      to="/enquiries/create"
                      className="btn btn-primary d-flex align-items-center gap-2"
                    >
                      <img src={plus_icon} alt="create" />
                      {t("Enquiry.Create")}
                    </Link>
                  </div>
                )}

                <div className="tale-text right-panel mobile-arrow">
                  <button
                    className="button left"
                    onClick={() => handleScroll("left")}
                  >
                    <img src={right_arrow} alt="left" />
                  </button>
                  <button
                    className="button right"
                    onClick={() => handleScroll("right")}
                  >
                    <img src={right_arrow} alt="right" />
                  </button>
                </div>
              </div>
            </div>

            <div className="timeto-hire-card userlist pendiglist-cardss">
              <div className="table-custome-class range-custome">
                 <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                <div className="table-wrapper" ref={tableWrapperRef}>
                  <BootstrapTable
                    keyField="id"
                    data={enquiryList}
                    columns={columns}
                    pagination={paginationFactory({
                      ...options,
                      page: currentPage,
                      sizePerPage: sizePerPage,
                      totalSize: totalSize,
                    })}
                    remote={{ pagination: true }}
                  onTableChange={(type, { page, sizePerPage }) => {
  const safePage = page < 1 ? 1 : page;
  fetchEnquiries(safePage, sizePerPage);
}}

                  />
                </div>
                </div>
                </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryList;
